const React = require("react");
const find = require("mn-utils/find");
const {isUserAccessed} = require("../../../../../../emitters/account");
const {PERMISSION_WITHDRAW} = require("../../../../../../constants/permissions");
const formatNumFiat = require("../../../../../../utils/formatNumFiat");
const {MerchantSelect} = require("../../../../../helpers/InputsHelpers");
const Ripple = require("../../../../../dumb/Ripple");
const {Link} = require("../../../../../../router");
const {LINK_WITHDRAW} = require("../../../../../../constants/links");
const {WITHDRAW_MIN_AMOUNT, WITHDRAW_MIN_AMOUNT_USD} = require('../../../../../../constants/withdrawalLimits');
const {Tooltip, Box, Grid} = require("@material-ui/core");
const {BtnBlueFilled} = require('../../../../../helpers/Buttons');

module.exports = ({assets, assetsLimits = {}, assetCode, handleChangeAssetCode, disabledBalance}) => {
  const asset = find(assets, ['asset_code', assetCode]) || {};

  const hasLimit = !!assetsLimits[assetCode];

  const withdrawMinAmount = hasLimit
    ? assetsLimits[assetCode]
    : WITHDRAW_MIN_AMOUNT;

  const amountTotal = asset.total || 0;
  const amountAvailable = asset.available || 0;
  const notEnoughBalance = Number(amountAvailable) < Number(withdrawMinAmount);

  const accessToWithdrawDisabled = !isUserAccessed(PERMISSION_WITHDRAW);
  const disabled = notEnoughBalance
    || accessToWithdrawDisabled
    || disabledBalance;

  return (
    <Grid container spacing={4}>
      <Grid item md={6} xs={12}>
        <div className="h94 layoutRow fvaC fhaB ph25 bgF6F6F6 r9">
          <div className="pr10 fx1 wmin0">
            <div className="f12 fw4 lts0em wsNW tov ov wmax">
              My Actual Balance
            </div>
            <div id="amountBalance" className="mt9 f23 fw7 lts0em wsNW tov ov w">
              {
                disabledBalance
                  ? '-'
                  : `${formatNumFiat(amountTotal)} ${assetCode}`
              }
            </div>
          </div>
          <div>
            <MerchantSelect
              id="mainCurrency"
              propName="asset_code"
              propValue="asset_code"
              displayEmpty
              items={assets}
              value={assetCode}
              onChange={handleChangeAssetCode}
              disabled={disabledBalance}
            />
          </div>
        </div>
      </Grid>
      <Grid item md={6} xs={12}>
        <div className="h94 rlv layoutRow fxdColumn jcC bgF6F6F6 ph25 r9">
          <div className="layoutRow fvaC fhaB">
            <div className="pr10 fx1 wmin0">
              <div className="f12 fw4 lts0em wsNW tov ov wmax">
                Available Balance
              </div>
              <div className="mt9 f23 fw7 lts0em wsNW tov ov wmax">
                {
                  disabledBalance
                    ? '-'
                    : `${formatNumFiat(amountAvailable)} ${assetCode}`
                }
              </div>
            </div>
            <div>
              <Box width="12rem">
                {disabled ? (
                  <Tooltip
                    title={
                      accessToWithdrawDisabled
                        ? 'You don\'t have permission to withdraw funds'
                        : notEnoughBalance
                          ? `Minimum withdrawal limit is ${formatNumFiat(withdrawMinAmount)} ${assetCode}`
                          : ''
                    }
                  >
                    <div>
                      <BtnBlueFilled
                        disabled={disabled}
                        heightMedium
                      >
                        Withdraw
                      </BtnBlueFilled>
                    </div>
                  </Tooltip>
                ) : (
                  <BtnBlueFilled
                    component={Link}
                    href={`${LINK_WITHDRAW}/${asset.type}/${assetCode}`}
                    heightMedium
                  >
                    Withdraw
                  </BtnBlueFilled>
                )}
              </Box>
            </div>
          </div>
          {!accessToWithdrawDisabled && (
            <div className="abs sb-25 sl0@d sr0 mt9 ph25 cA3A7AC f12 fw4 lts0em">
              {hasLimit
                ? `*Minimum withdrawal limit is ${formatNumFiat(withdrawMinAmount)} ${assetCode}`
                : `Minimum withdrawal limit is ${withdrawMinAmount} EUR or similar in the local currency`
              }
            </div>
          )}
        </div>
      </Grid>
      {/*<div className="cfx mh-34 mr-20@m (w1/2|w@m|ph34|ph20@m|lt)>1">*/}
      {/*  <div>*/}
      {/*    <div className="h94 layoutRow fvaC fhaB ph25 bgF6F6F6 r9">*/}
      {/*      <div className="pr10 fx1 wmin0">*/}
      {/*        <div className="f12 fw4 lts0em wsNW tov ov wmax">*/}
      {/*          My Actual Balance*/}
      {/*        </div>*/}
      {/*        <div className="mt9 f23 fw7 lts0em wsNW tov ov w">*/}
      {/*          {*/}
      {/*            disabledBalance*/}
      {/*              ? '-'*/}
      {/*              : `${formatNumFiat(amountTotal)} ${assetCode}`*/}
      {/*          }*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*      <div>*/}
      {/*        <MerchantSelect*/}
      {/*          propName="asset_code"*/}
      {/*          propValue="asset_code"*/}
      {/*          displayEmpty*/}
      {/*          items={assets}*/}
      {/*          value={assetCode}*/}
      {/*          onChange={handleChangeAssetCode}*/}
      {/*          disabled={disabledBalance}*/}
      {/*        />*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <div className="mt36@m">*/}
      {/*    <div className="h94 layoutRow fxdColumn jcC bgF6F6F6 ph25 r9">*/}
      {/*      <div className="layoutRow fvaC fhaB">*/}
      {/*        <div className="pr10 fx1 wmin0">*/}
      {/*          <div className="f12 fw4 lts0em wsNW tov ov wmax">*/}
      {/*            Available Balance*/}
      {/*          </div>*/}
      {/*          <div className="mt9 f23 fw7 lts0em wsNW tov ov wmax">*/}
      {/*            {*/}
      {/*              disabledBalance*/}
      {/*                ? '-'*/}
      {/*                : `${formatNumFiat(amountAvailable)} ${assetCode}`*/}
      {/*            }*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*        <div>*/}
      {/*          <Ripple*/}
      {/*            component={Link}*/}
      {/*            className="layoutRow fvaC fhaC f16 fw4 lts0em cF w120 h45 ttU usN*/}
      {/*                bgC.disabled r9 ov bg5B47FF bg4B37EF:not[.disabled]:h dn"*/}
      {/*            href={`${LINK_WITHDRAW}/${asset.type}/${assetCode}`}*/}
      {/*            disabled={disabled}*/}
      {/*          >Withdraw</Ripple>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <div className="h1">*/}
      {/*    <div className="mh-25 ph25" />*/}
      {/*  </div>*/}
      {/*  <div>*/}
      {/*    <div className="mt9 mh-25 ph25 cA3A7AC f12 fw4 lts0em">*/}
      {/*      *Minimum withdrawal limit is {withdrawMinAmount} {assetCode}*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </Grid>
  );

}
